import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  isNavOpen: boolean
  isRouteTransition: boolean
  isFooterVisible: boolean
  isSearchModalOpen: boolean
  isNavReduced: boolean
}
interface Action {
  setIsSearchModalOpen: (isSearchModalOpen: State['isSearchModalOpen']) => void
  setIsFooterVisible: (isFooterVisible: State['isFooterVisible']) => void
  setIsNavOpen: (isNavOpen: State['isNavOpen']) => void
  setIsNavReduced: (isNavReduced: State['isNavReduced']) => void
  setToggleNavOpen: () => void
  setIsRouteTransition: (isRouteTransition: State['isRouteTransition']) => void
  reset: () => void
}

const baseStoreNavigation = create<State & Action>((set) => ({
  isNavOpen: false,
  isFooterVisible: false,
  isNavReduced: false,
  isRouteTransition: false,
  isSearchModalOpen: false,
  setIsSearchModalOpen: (isSearchModalOpen) =>
    set(() => ({ isSearchModalOpen })),
  setIsNavReduced: (isNavReduced) => set(() => ({ isNavReduced })),
  setIsFooterVisible: (isFooterVisible) => set(() => ({ isFooterVisible })),
  setIsNavOpen: (isNavOpen) => set(() => ({ isNavOpen })),
  setToggleNavOpen: () => set((state) => ({ isNavOpen: !state.isNavOpen })),
  setIsRouteTransition: (isRouteTransition) =>
    set(() => ({ isRouteTransition })),
  reset: () =>
    set({
      isNavOpen: false,
      isFooterVisible: false,
      isRouteTransition: false,
      isNavReduced: false
    })
}))

const useStoreNavigation = createSelectors(baseStoreNavigation)

export default useStoreNavigation
